import React from 'react';
import Box from '@mui/material/Box';

function ViewSelectorContainer({
  children,
  orientation = 'vertical',
  sx = {},
  className = '',
}) {
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        flexDirection: orientation === 'vertical' ? 'column' : 'row',
        gap: '4px',
        justifyItems: 'center',
        padding: '6px',
        borderRadius: '999px',
        backdropFilter: 'blur(2px)',
        backgroundColor: 'rgba(255,255,255,0.9)',
        color: 'black',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'grey.600',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default ViewSelectorContainer;
